import React from 'react';
import { CopyableBlock } from '../CopyableBlock';

export const SocialOutputs = ({ data }) => {
  if (!data) return null;
  const carousel = data.carousel || {};
  const slides = [
    ['Slide 1 — Hook', carousel.slide_1_hook],
    ['Slide 2 — Challenge', carousel.slide_2_challenge],
    ['Slide 3 — Intervention', carousel.slide_3_intervention],
    ['Slide 4 — Outcome', carousel.slide_4_outcome],
    ['Slide 5 — Grow Your Tomorrow Today', carousel.slide_5_cta],
  ];
  const allSlides = slides.map(([label, txt]) => `${label}: ${txt || ''}`).join('\n\n');
  const hashtags = Array.isArray(data.hashtags) ? data.hashtags.join(' ') : '';

  return (
    <div data-testid="output-social">
      <CopyableBlock
        label="Single-image caption"
        content={data.single_image_caption}
        testId="sc-single"
      />
      <h4 className="text-sm font-bold text-gray-900 mb-3 mt-4">Carousel</h4>
      {slides.map(([label, txt]) => (
        <CopyableBlock key={label} label={label} content={txt} testId={`sc-${label.split(' ')[1]}`} />
      ))}
      <CopyableBlock label="Full Carousel (all slides)" content={allSlides} mono testId="sc-all" />
      <CopyableBlock label="Hashtags" content={hashtags} testId="sc-hashtags" />
    </div>
  );
};

export default SocialOutputs;
